import { casingUtil } from '@/utils'

export const resolvePledgeDown = casingUtil.snakeToCamel

export const resolvePledgeUp = casingUtil.camelToSnake
